<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import ChatRoomItemTypeGuard from "../Models/Typeguards/ChatRoomItem";
import type { AllowedChatRoomItemType } from "@/Modules/Chat/Models/Domain/Chat";

import { parseUrls, isUrl } from "@/Modules/Chat/Components/utils/TextMessagesParsers";
import { isObject } from "@/Utils/Objects";
import { isString } from "@/Utils/String";

export interface EventTextProps {
  event: AllowedChatRoomItemType;
}

const props = defineProps<EventTextProps>();
const { t } = useI18n();

const url = computed((): string => {
  if (isObject(props.event) && isString(props.event.text)) {
    return parseUrls(props.event.text);
  }

  return "";
});
</script>

<template>
  <span v-if="isObject(props.event) && isString(props.event.text)">
    <a v-if="isUrl(props.event.text)" target="_blank" :href="url">
      {{ props.event.text }}
    </a>

    <template v-else> {{ props.event.text }}</template>
  </span>

  <span v-else-if="ChatRoomItemTypeGuard.isCustom(event) && event.i18nKey">
    {{ t(event.i18nKey, event.params ? event.params : {}) }}
  </span>

  <span v-else />
</template>
